import { CatInputField } from '@blocks-react/components/InputField';
import { useInputController } from '@cat-ecom/pcc-components/src/hooks/form-controllers';
import { Props } from './types';
import { getNotation } from './utils';

const GuestInputFormText = ({
  name = '',
  label = '',
  type = 'text',
  placeholder = '',
  maxlength,
  required = false,
  disabled = false,
  t,
  error,
  rules = {}
}: Props) => {
  const { inputField } = useInputController({ name, rules });

  return (
    <CatInputField
      {...inputField}
      notation={getNotation(t, required)}
      type={type}
      fieldId={name}
      name={name}
      label={label}
      placeholder={placeholder}
      required={required}
      disabled={disabled}
      data-testid={`${name}-test`}
      maxlength={maxlength}
      className="data-cs-mask"
      data-cs-mask
      status={error ? 'error' : undefined}
    />
  );
};

export default GuestInputFormText;
